import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BAMSCoursePage: React.FC = () => {
  const courseData = {
    title: "BAMS - Bachelor of Ayurvedic Medicine & Surgery",
    shortName: "BAMS",
    duration: "5.5 years (4.5 years + 1 year internship)",
    description: "Traditional Indian medicine system with modern medical integration",
    overview: "Bachelor of Ayurvedic Medicine and Surgery (BAMS) is an undergraduate degree program that focuses on the traditional Indian system of medicine - Ayurveda. This course integrates ancient Ayurvedic principles with modern medical knowledge to produce qualified Ayurvedic practitioners who can diagnose, treat, and prevent diseases using natural remedies and traditional healing methods.",
    eligibility: [
      "10+2 with Physics, Chemistry, Biology",
      "Minimum 50% marks (40% for SC/ST)",
      "NEET qualification mandatory",
      "Age: 17-25 years"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Sanskrit",
          "Padartha Vigyan (Basic Principles of Ayurveda)",
          "Ayurveda Itihas (History of Ayurveda)",
          "Kriya Sharir (Physiology)",
          "Rachana Sharir (Anatomy)",
          "Maulik Siddhanta (Fundamental Principles)"
        ]
      },
      {
        year: 2,
        subjects: [
          "Dravyaguna (Pharmacology)",
          "Rasa Shastra (Pharmaceutics)",
          "Bhaishajya Kalpana (Pharmacy)",
          "Swasthavritta (Preventive Medicine)",
          "Yoga & Naturopathy",
          "Research Methodology"
        ]
      },
      {
        year: 3,
        subjects: [
          "Roga Nidan (Pathology)",
          "Charaka Samhita",
          "Sushruta Samhita",
          "Vikruti Vigyan (Pathophysiology)",
          "Agadtantra (Toxicology)",
          "Vyavaharayurveda (Forensic Medicine)"
        ]
      },
      {
        year: 4,
        subjects: [
          "Kayachikitsa (Internal Medicine)",
          "Panchakarma",
          "Shalya Tantra (Surgery)",
          "Shalakya Tantra (ENT & Ophthalmology)",
          "Prasuti Tantra (Obstetrics & Gynecology)",
          "Kaumarbhritya (Pediatrics)"
        ]
      },
      {
        year: 5,
        subjects: [
          "Clinical Training in Ayurvedic Hospitals",
          "Practical Application of Ayurvedic Treatments",
          "Patient Care and Management",
          "Research Project",
          "Community Health Programs",
          "Integration with Modern Medicine"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Ayurvedic Doctor/Physician",
        "Ayurvedic Consultant",
        "Research Scientist",
        "Medical Officer (Ayurveda)",
        "College Professor/Lecturer",
        "Ayurvedic Product Developer",
        "Wellness Center Manager",
        "Panchakarma Specialist",
        "Ayurvedic Pharmacist",
        "Health Content Writer"
      ],
      industries: [
        "Government Hospitals",
        "Private Ayurvedic Clinics",
        "Wellness Centers",
        "Pharmaceutical Companies",
        "Research Institutions",
        "Educational Institutions",
        "Health Tourism",
        "Ayurvedic Product Manufacturing",
        "NGOs and Community Health",
        "Alternative Medicine Centers"
      ],
      averageSalary: "₹3-8 LPA",
      topRecruiters: [
        "Government Hospitals",
        "Dabur India Ltd",
        "Himalaya Drug Company",
        "Patanjali Ayurved",
        "Wellness Centers",
        "Research Institutes"
      ]
    },

    topColleges: [
      {
        name: "Institute of Medical Sciences, Banaras Hindu University",
        location: "Varanasi, Uttar Pradesh",
        fees: "₹25,000/year",
        ranking: "9.2/10"
      },
      {
        name: "Tilak Ayurved Mahavidyalaya",
        location: "Pune, Maharashtra",
        fees: "₹45,000/year",
        ranking: "8.9/10"
      },
      {
        name: "National Institute of Ayurveda",
        location: "Jaipur, Rajasthan",
        fees: "₹30,000/year",
        ranking: "9.0/10"
      },
      {
        name: "SDM College of Ayurveda",
        location: "Udupi, Karnataka",
        fees: "₹75,000/year",
        ranking: "8.7/10"
      },
      {
        name: "Ayurveda Mahavidyalaya",
        location: "Hubli, Karnataka",
        fees: "₹60,000/year",
        ranking: "8.5/10"
      }
    ],

    skills: [
      "Traditional Diagnostic Methods",
      "Pulse Diagnosis (Nadi Pariksha)",
      "Herbal Medicine Preparation",
      "Panchakarma Procedures",
      "Patient Counseling",
      "Research and Analysis",
      "Sanskrit Proficiency",
      "Meditation and Yoga",
      "Natural Therapy Techniques",
      "Holistic Health Assessment"
    ],

    futureScope: "Growing acceptance of alternative medicine, integration with modern healthcare systems, government initiatives promoting AYUSH, international demand for Ayurvedic practitioners, research opportunities in traditional medicine, wellness tourism industry growth, pharmaceutical industry integration, telemedicine and digital health platforms, preventive healthcare focus, and academic research positions.",

    faqs: [
      {
        question: "Is BAMS a recognized medical degree?",
        answer: "Yes, BAMS is a recognized medical degree under the Central Council of Indian Medicine (CCIM) and Ministry of AYUSH, Government of India."
      },
      {
        question: "Can BAMS graduates practice modern medicine?",
        answer: "BAMS graduates primarily practice Ayurvedic medicine. However, they can pursue additional qualifications or specializations to expand their practice scope."
      },
      {
        question: "What is the scope of BAMS in government jobs?",
        answer: "BAMS graduates can apply for Medical Officer positions in government hospitals, AYUSH departments, and various state government health services."
      },
      {
        question: "Can I pursue MD after BAMS?",
        answer: "BAMS graduates can pursue MS (Ayurveda) for specialization in various Ayurvedic disciplines, which is equivalent to MD in modern medicine."
      },
      {
        question: "Is NEET required for BAMS admission?",
        answer: "Yes, NEET is mandatory for admission to BAMS courses in all medical colleges across India."
      },
      {
        question: "What is the difference between BAMS and MBBS?",
        answer: "BAMS focuses on traditional Ayurvedic medicine while MBBS focuses on modern allopathic medicine. Both are recognized medical degrees with different treatment approaches."
      }
    ],

    admissionProcess: [
      "NEET Qualification",
      "State/National Counseling Registration",
      "Choice Filling & Document Verification",
      "Seat Allotment",
      "College Reporting & Fee Payment"
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BAMSCoursePage;
